var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPDashText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5H4C2.897 2.5 2 3.394 2 4.492V16.508C2 17.606 2.897 18.5 4 18.5H7V22.5L13.351 18.5H20C21.103 18.5 22 17.606 22 16.508V4.492C21.9984 3.96279 21.7869 3.45583 21.412 3.08237C21.037 2.70891 20.5292 2.49947 20 2.5ZM14 13.5H7V11.5H14V13.5ZM17 9.5H7V7.5H17V9.5Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDashText);
export default __webpack_public_path__ + "static/media/p_dash_text.bb8371b3d29217fcd50110c5456eff53.svg";
export { ForwardRef as ReactComponent };